import React from "react";
import { Container } from "@shared/ui/container";
import styles from "./rules-content.module.scss";

const RulesContent: React.FC = () => {
    return (
        <Container>
            <div className={styles.RulesHeaderContent}>
                <h1>Правила использования сервиса Likvi (агрегатора поиска авто)</h1>
            </div>
            <div className={styles.RulesContent}>
                <h2>1. Общие положения</h2>
                <p>
                    1.1. Сервис Likvi (далее — «Сервис») является агрегатором данных об автомобилях
                    и предоставляет пользователям возможность проверки истории транспортных средств
                    по VIN-коду или государственному номеру.
                </p>
                <p>
                    1.2. Используя Сервис, вы соглашаетесь с настоящими Правилами и обязуетесь
                    соблюдать их. Регистрация на сервисе и использование его функционала
                    автоматически подтверждает принятие настоящих Правил пользователем.
                </p>
                <p>
                    1.3. Сервис предоставляется ООО «Likvi». Компания обеспечивает функционирование
                    платформы и гарантирует соблюдение требований действующего законодательства
                    Российской Федерации.
                </p>
                <p>
                    1.4. Сервис не связан с государственными реестрами и использует данные из
                    коммерческих и открытых источников.
                </p>

                <h2>2. Услуги Сервиса</h2>
                <p>
                    2.1. Сервис предоставляет пользователям доступ к платным отчетам об автомобилях,
                    содержащим информацию из открытых и коммерческих источников (далее — «Отчеты»).
                </p>
                <p>
                    2.2. Отчеты формируются на основании данных, предоставляемых сервис-партнерами —
                    системой Автотека и других проверенных источников.
                </p>
                <p>
                    2.3. Отчет включает сведения о техническом состоянии транспортного средства,
                    историю владения автомобилем, ограничения регистрационных действий, количество
                    владельцев, данные технического осмотра и другие характеристики, позволяющие
                    оценить качество и надежность приобретаемого автомобиля.
                </p>
                <p>
                    2.4. Сервис не является собственником или распространителем исходных данных, а
                    лишь агрегирует и предоставляет их в удобном формате.
                </p>
                <p>
                    2.5. Сервис не гарантирует полноту и 100% точность данных, так как информация
                    зависит от источников.
                </p>

                <h2>3. Условия использования</h2>
                <p>3.1. Для получения Отчета пользователь должен:</p>
                <ul>
                    <li>
                        Пройти процедуру регистрации путем заполнения анкеты на официальном
                        веб-сайте сервиса и подтвердить свою личность способами, предусмотренными
                        правилами регистрации.
                    </li>
                    <li>
                        Перед началом использования услуг внимательно изучить настоящие Правила и
                        ознакомиться с актуальной информацией о стоимости услуг.
                    </li>
                    <li>
                        Указать VIN-код или государственный номер автомобиля по зарегистрированным
                        государственным номерам и VIN-кодам транспортных средств, зарегистрированных
                        на территории Российской Федерации.
                    </li>
                    <li>Оплатить услугу в соответствии с действующими тарифами.</li>
                </ul>
                <p>
                    3.2. Отчеты предоставляются в электронном виде и доступны для скачивания в
                    личном кабинете пользователя.
                </p>
                <p>
                    3.3. Сервис не гарантирует 100% точность и полноту данных в Отчетах, так как
                    информация зависит от источников.
                </p>
                <p>3.4. Запрещено использовать Сервис для мошенничества или незаконных действий.</p>
                <p>
                    3.5. Сервис не принимает запросы, касающиеся транспортных средств, находящихся
                    вне юрисдикции Российской Федерации.
                </p>
                <p>
                    3.6. Отчет предоставляется исключительно для информационных целей и не является
                    официальным документом, подтверждающим юридический статус транспортного
                    средства.
                </p>
                <p>
                    3.7. Сервис оказывает помощь в подборе транспортного средства посредством
                    анализа истории эксплуатации, технического состояния и иных факторов, влияющих
                    на решение покупателя.
                </p>
                <p>
                    3.8. Пользователь самостоятельно оценивает полноту и точность представленной
                    информации перед принятием решений о покупке автомобиля.
                </p>
                <p>
                    3.9. Право на пользование услугами прекращается автоматически в случае
                    неисполнения пользователем обязанностей, предусмотренных настоящими Правилами.
                </p>
                <p>
                    3.10. Администрация сервиса вправе временно ограничить доступ к сервису при
                    выявлении нарушений, злоупотреблений или недобросовестного поведения
                    пользователя.
                </p>
                <p>
                    3.11. Действие права на использование услуг также прекращается при ликвидации
                    юридического лица или закрытии аккаунта физического лица по собственной
                    инициативе.
                </p>

                <h2>4. Оплата и возврат средств</h2>
                <p>4.1. Стоимость Отчетов определяется тарифами, указанными на сайте Сервиса.</p>
                <p>
                    4.2. Оплата производится безналичным способом через платежные системы,
                    интегрированные в Сервис.
                </p>
                <p>
                    4.3. Возврат средств возможен только в случае технической ошибки, приведшей к
                    невозможности получения Отчета.
                </p>
                <p>
                    4.4. Сервис оставляет за собой право изменять тарифы на оказываемые услуги без
                    предварительного уведомления пользователей.
                </p>

                <h2>5. Ответственность</h2>
                <ul>
                    <li>
                        Сервис не несет ответственности за решения, принятые пользователями на
                        основе отчетов.
                    </li>
                    <li>Неточности в данных из-за ошибок источников.</li>
                    <li>Использование отчетов в незаконных целях.</li>
                    <li>
                        За содержание и достоверность представленных в отчете данных, поскольку
                        информация берется из открытых источников и баз данных партнеров.
                    </li>
                </ul>
                <p>
                    5.2. Запрещено использовать данные Отчетов в незаконных целях или для
                    мошеннических действий.
                </p>
                <p>
                    5.3. За неполучение запрашиваемой информации либо получение некорректных данных
                    вследствие технических сбоев Сервис ответственности не несёт.
                </p>
                <p>
                    5.4. Сервис вправе приостановить предоставление услуг пользователю в случаях
                    нарушения условий настоящего Соглашения.
                </p>
                <p>
                    5.5. Сервис не осуществляет проверку законности сделок купли-продажи
                    транспортных средств и не несет ответственности за убытки, понесенные клиентами
                    в результате принятия неверных решений на основе предоставленных отчетов.
                </p>
                <p>
                    5.6. Сервис освобождается от ответственности за возможные перебои в работе или
                    задержку оказания услуг, вызванные техническими причинами, форс-мажорными
                    обстоятельствами или действиями третьих лиц.
                </p>

                <h2>6. Конфиденциальность</h2>
                <p>
                    6.1. Сервис обязуется не передавать персональные данные пользователей третьим
                    лицам без их согласия, за исключением случаев, предусмотренных
                    законодательством.
                </p>
                <p>
                    6.2. Информация, предоставляемая Пользователю через сервис, является
                    конфиденциальной и предназначена только для личного использования Покупателя.
                </p>
                <p>
                    6.3. VIN и гос. номера используются только для формирования отчетов и не
                    хранятся дольше необходимого.
                </p>
                <p>
                    6.4. Любое распространение данной информации третьим лицам возможно лишь с
                    письменного разрешения собственника транспортного средства.
                </p>

                <h2>7. Заключительные положения</h2>
                <p>
                    7.1. Сервис оставляет за собой право вносить изменения в настоящие Правила.
                    Актуальная версия всегда доступна на сайте.
                </p>
                <p>
                    7.2. Все споры и разногласия разрешаются сторонами путем переговоров и взаимных
                    консультаций. В случае невозможности урегулирования споров мирным путем они
                    рассматриваются в судебном порядке в соответствии с законодательством Российской
                    Федерации.
                </p>
                <p>
                    7.3. По вопросам работы сервиса:{" "}
                    <a href="mailto:support@likvi.com">support@likvi.com</a>
                </p>
                <p>Дата последнего обновления: 16.04.2025</p>
            </div>
        </Container>
    );
};

export default RulesContent;